import { Theme } from "./Theme";

export const lightHighContrastTheme: Theme = {
  colors: {
    neutral: {
      background: "#ffffff",
      text: "#000000",
      border: "#000000",
      secondaryText: "#000000",
      imageFallbackBackground: "#eaeaea",
      buttonBackground: "#eaeaea",
      dropdownSelected: "#0062ff",
      orgUnderlineColor: "#0062ff",
      tabColor: "#000000",
      selectedTabColor: "#0062ff",
    },
  },
};
